import React from 'react';
import styles from './Footer.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome CSS

const Footer = () => {
    return (
        <footer className={`site-footer ${styles.footer}`}>

            <a href="/downloads/Freed%20Resume.pdf" download="Freed Resume.pdf" aria-label="Download resume PDF">
                <i className={`fas fa-file ${styles.icon}`}></i>
                Resume
            </a>
            <a href="https://www.linkedin.com/in/ethan-freed-ucla/" target="_blank" rel="noopener noreferrer">
                <i className={`fab fa-linkedin ${styles.icon}`}></i>
                LinkedIn
            </a>

            <a href="https://docs.google.com/document/d/1JlMY4K5ZXSEl7tbwOfZ_5aoQ-HXeSIQKgTGZd5FrtTI/export?format=pdf" target='_blank' rel="noopener noreferrer">
                <i className={`fas fa-file ${styles.icon}`}></i>
                Portfolio
            </a>




        </footer>
    );
};

export default Footer;
